import {
  ApiEnvironment,
  getBasePath,
  getCorsConfiguration,
} from './environment'
import { IApplicantData } from '../types/tink.interface'

export type EventType =
  | 'started'
  | 'success'
  | 'failed'
  | 'aborted'
  | 'accountSelection'

const publishEvent = (
  environment: ApiEnvironment,
  type: EventType,
  request: IApplicantData,
): void => {
  fetch(`${getBasePath(environment)}/v1/publish/event/${type}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      client_uuid: request.clientUuid,
      person_id: request.personId,
      lead_uuid: request.loanLeadUuid,
      origin: request.origin.toUpperCase(),
      transaction_id: request.transactionId,
      application_uuid: request.applicationUuid,
      customer_uuid: request.customerUuid,
    }),
    ...getCorsConfiguration(environment),
  }).catch((error) => {
    // Given that the package does not provide a clear error handling/logging strategy, for now it just logs
    // eslint-disable-next-line no-console
    console.error(error)
  })
}

export default publishEvent
